import React from 'react'
import logo from "../assets/img/Aays.png";
import aadiLogo from "../assets/img/aadi-login-logo.png";
import "bootstrap/dist/css/bootstrap.min.css";
import "./SigninWidget.scss";
import { useMsal } from '@azure/msal-react';
import { loginRequest } from './authConfig';
import bgimage from "../assets/img/LoginPage.gif";
import microsoft from "../assets/img/microsoft.png";
const Login = () => {

    const { instance } = useMsal(); // Access MSAL instance from context

    const loginBtn = async () => {
      try {
        const loginResponse = await instance.loginPopup(loginRequest); // Trigger login popup
        console.log("Login successful", loginResponse);
    
      } catch (error) {
        console.error("Login failed", error);
      }
    };

  return (
    <div
    // style={{ backgroundImage: `url(${bgimage})` }}
    className="relative min-h-screen bg-black overflow-hidden"
  >
    <div className="relative w-full h-full">
  <img
    src={bgimage}
    alt="Background"
    className="absolute top-0 left-0 w-full h-[100vh] object-cover"
  />
  <div className="absolute top-0 left-0 right-0 h-6 bg-gradient-to-r from-[#bb1ccc]/20 to-[#bb1ccc]/10 z-10 h-[100vh]"></div>
</div>


    {/* Login Form */}
    <div className="relative z-10 flex items-center justify-center min-h-[calc(100vh-100px)] mt-8">
      <div
        style={{ border: "2px solid #bb1ccc" }}
        className="bg-[#000000] rounded-2xl p-8 w-full max-w-md mx-4"
      >
        <div className="text-center mb-8">
          <img
            src={aadiLogo}
            alt="Logo"
            className="mx-auto mb-4 w-[106px] h-auto"
          />
          <h1 className="text-[32px] font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#FFFFFF] to-[#FFFFFF] mb-2">
            Welcome back!
          </h1>
          <p className="text-gray-300 text-[14px]">
          Aays Decision Intelligence Co-Pilot for Supply Chain
          </p>
        </div>

        <div className="space-y-6">
          <button
            onClick={loginBtn}
            style={{ border: "none" }}
            className="w-full bg-gradient-to-r from-[#bb1ccc] to-[#bb1ccc] text-white py-3 rounded-lg font-semibold hover:from[#bb1ccc]/50 hover:to-[#bb1ccc]/60 transition-all duration-200 transform hover:scale-105 flex items-center justify-center gap-2"
          >
           <span>
           <img width={20} src={microsoft} alt='Login'/> 
           </span>
           <span>Sign In with Microsoft</span>
          </button>

          <div className=''>
          <p className="text-center text-gray-300 text-sm">
            Don't have an account?{" "}
            {/* <a href="#" className="text-purple-400 hover:text-purple-300 transition-colors">
              Sign up here
            </a> */}
          </p>

          <p className="text-center text-gray-300 text-sm">
           Need help?{" "}
            {/* <a href="#" className="text-purple-400 hover:text-purple-300 transition-colors">
              Sign up here
            </a> */}
          </p>
          </div>
        </div>
      </div>
    </div>

    {/* Bottom gradient bar */}
    <div className="absolute bottom-0 left-0 right-0 h-6 bg-gradient-to-r from-[#bb1ccc] to-[#bb1ccc]"></div>
  </div>
  )
}

export default Login